/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{AComputedField as e}from"./AComputedField.js";class r extends e{constructor(e){super(),this._value=e}resize(e){}read(e,r){return this._value}readWithDefault(e,r,t){return this._value}hasArcadeDependency(e){return!1}}export{r as DictionaryValue};
